import React from "react";
import { useQuery } from "@apollo/client";
import qDebugBar from "@assets/gql/debugBar.gql";
import { createPortal } from "react-dom";
import { useLocation } from "react-router-dom";
const debugBar = typeof document !== 'undefined' ? document.getElementById('debug-bar') : null;
export function DebugBar() {
    if (!debugBar)
        return null;
    return createPortal(React.createElement(DebugBarContent, null), debugBar);
}
function DebugBarContent() {
    var _a, _b;
    const { pathname, search } = useLocation();
    const { data, loading } = useQuery(qDebugBar, {
        variables: { uri: pathname + search }
    });
    return React.createElement("div", { className: "ltg-debug-bar", style: { background: '#272727', padding: 5, display: 'flex', alignItems: 'center', gap: 16, minHeight: 34 } },
        React.createElement("div", { className: "container" }, !loading && ((_b = (_a = data === null || data === void 0 ? void 0 : data.debugBar) === null || _a === void 0 ? void 0 : _a.items) === null || _b === void 0 ? void 0 : _b.map(mapItems))));
}
function mapItems({ extendContent, isExtendable, href, icon, title }) {
    return React.createElement("a", { href: href, target: "_blank", key: href }, title);
}
